






/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getNetBankingPurchasesByCreator
// GETNETBANKINGPURCHASESBYCREATOR
const GETNETBANKINGPURCHASESBYCREATOR= createAsyncThunk(
  "getNetBankingPurchasesByCreator/getNetBankingPurchasesByCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getNetBankingPurchasesByCreatorSlice = createSlice({
  name: "getNetBankingPurchasesByCreatorSlice",
  initialState: {
    getNetBankingPurchasesByCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetNetBankingPurchasesByCreator: (state) => {
        state.getNetBankingPurchasesByCreator.loading = false
        state.getNetBankingPurchasesByCreator.error = false
        state.getNetBankingPurchasesByCreator.data = []
        state.getNetBankingPurchasesByCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETNETBANKINGPURCHASESBYCREATOR.fulfilled, (state, action) => {
      state.getNetBankingPurchasesByCreator = {
        ...state.getNetBankingPurchasesByCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETNETBANKINGPURCHASESBYCREATOR.pending, (state, action) => {
      state.getNetBankingPurchasesByCreator = {
        ...state.getNetBankingPurchasesByCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETNETBANKINGPURCHASESBYCREATOR.rejected, (state, action) => {
      state.getNetBankingPurchasesByCreator = {
        ...state.getNetBankingPurchasesByCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getNetBankingPurchasesByCreatorAction = {
    GETNETBANKINGPURCHASESBYCREATOR,
};

export { getNetBankingPurchasesByCreatorAction };
export default getNetBankingPurchasesByCreatorSlice.reducer;
export const {setInitialStateOfgetNetBankingPurchasesByCreator} = getNetBankingPurchasesByCreatorSlice.actions
